module.exports = __webpack_public_path__ + "img/read_white.fafa30ff.svg";